
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ChatLogsContent } from '@/components/admin/chatlogs/ChatLogsContent';

export default function ChatLogs() {
  return (
    <AdminLayout>
      <div className="p-6 space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Chat Logs</h1>
        </div>
        
        <ChatLogsContent />
      </div>
    </AdminLayout>
  );
}
